import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { BillingReportFilter, BillingReportItem } from '@shared/interfaces/billing.interface';
import { PmsSyncConfigurationModel } from '@shared/interfaces/pms-credential-model.interface';
import { UserToGeneralRoleModel } from '@shared/interfaces/user-to-general-role-model';
import { UserToPropertyMapping } from '@shared/interfaces/user-to-property-mapping';

@Injectable({
  providedIn: 'root',
})
export class AdminPanelService {
  constructor(private restApiService: RestapiService) {}

  setUserToGeneralRole(usersToGeneralRoleList: UserToGeneralRoleModel[]): Observable<boolean> {
    return this.restApiService.create<boolean>(`AdminPanel/UserToGeneralRole`, usersToGeneralRoleList);
  }

  setUserToPropertyRole(userToPropertyRoleList: UserToPropertyMapping[]): Observable<boolean> {
    if (!userToPropertyRoleList?.length) {
      return of(false);
    }

    return this.restApiService.create<boolean>(`AdminPanel/UserToPropertyRole`, userToPropertyRoleList);
  }

  removeUserFromPropertyRole(propertyId: number[]): Observable<boolean> {
    if (!propertyId?.length) {
      return of(false);
    }

    return this.restApiService.create<boolean>(`AdminPanel/UserToPropertyRole/remove`, propertyId);
  }

  billingReport(filter: BillingReportFilter): Observable<BillingReportItem[]> {
    return this.restApiService.getData<BillingReportItem[]>(
      `AdminPanel/BillingReport?startDate=${filter.startDate.toISOString()}&endDate=${filter.endDate.toISOString()}`
    );
  }

  runImporterNow(): Observable<any> {
    return this.restApiService.getData<any>(`AdminPanel/runImporterNow`);
  }

  testUrl(url: string): Observable<any> {
    return this.restApiService.getData<any>(`AdminPanel/testApiUrl?url=${url}`);
  }

  editWorkflowStepTemplate(stepEnumType: WorkflowStepEnumType, stepName: string): Observable<void> {
    return this.restApiService.create<void>('AdminPanel/editWorkflowStepTemplate', {
      stepEnumType,
      stepName,
    });
  }

  updatePmsConfiguration(config: PmsSyncConfigurationModel): Observable<void> {
    return this.restApiService.create<void>('AdminPanel/pmsSyncConfiguration', config);
  }
}
